// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

import superagent from 'superagent';
import fingerprintjs2 from 'fingerprintjs2';

const deviceIdGenerator = fingerprintjs2.getPromise({})
  .then(values => fingerprintjs2.x64hash128(values.map(v => v.value).join(''), 31))
  .catch(() => 'unrecognised');

export const post = (url: string, body: { [string]: any }): Promise<any> => deviceIdGenerator.then(id => superagent('POST', url)
  .set('Accept', 'application/json')
  .set('X-Device-Id', id)
  .withCredentials()
  .send(body));

export const redirect = (uri: string) => {
  window.location.assign(uri);
};
